import React from 'react';
import { Modal } from 'react-bootstrap';
import useShowBooking from '../../../services/booking/hooks/useShowBooking';
import FormError from '../errors/FormError';
import TooltipContentNew1 from '../../../features/pms-calendar/components/calendar/TooltipContentNew1';

interface BookingDetailModalV2Props {
    bookingId: string;
    show: boolean;
    onClose: () => void;
    onUpdate: (id: string) => void;
    onUpdateStatus: (id: string) => void;
    onUpdateComment: (id: string) => void;
    onAddPayment: (id: string) => void;
    onAddExtra: (id: string) => void;
    onSwitch?: (id: string) => void;
    onSplit?: (id: string) => void;
    onMerge?: (id: string) => void;
}

const BookingDetailModalV2: React.FC<BookingDetailModalV2Props> = ({
    bookingId,
    show,
    onClose,
    onUpdate,
    onUpdateStatus,
    onUpdateComment,
    onAddPayment,
    onAddExtra,
    onSwitch,
    onSplit,
    onMerge,
}) => {
    const { data: bookingData, isFetching, isSuccess, isError } = useShowBooking({
        bookingId: bookingId,
    });

    return (
        <Modal show={show} onHide={onClose} size="lg" centered backdrop="static" keyboard={false}>
            <Modal.Body className="p-0">
                {isError && (
                    <div className="d-flex justify-content-center p-4">
                        <FormError />
                    </div>
                )}
                {isFetching && (
                    <div className="d-flex justify-content-center p-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
                {isSuccess && !isFetching && bookingData && (
                    <TooltipContentNew1
                        booking={bookingData}
                        onUpdate={onUpdate}
                        onComment={onUpdateComment}
                        onUpdateStatus={onUpdateStatus}
                        onAddPayment={onAddPayment}
                        onAddExtra={onAddExtra}
                        onSwitch={onSwitch}
                        onSplit={onSplit}
                        onMerge={onMerge}
                        onClose={onClose}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default BookingDetailModalV2;
